import { createAsyncThunk } from '@reduxjs/toolkit';
import * as types from '../types';

export const unit = createAsyncThunk<unknown, void, { state: types.State; extra: types.Config }>(
  'state/thunk/unit',
  () => null
);

export type Thunk = ReturnType<typeof unit>;
